<div>
  <ng-container *ngIf="activity.isLoggedActivity; else systemActivity">
    <div
      *ngIf="isActivityValid()"
      [ngSwitch]="activity.crmObjectSubtype"
      class="activity-card"
      [ngClass]="{ 'last-activity-card': isLast }"
    >
      <ng-template #taskSubtitle>
        <ng-container
          *ngTemplateOutlet="
            (activity | crmIsTaskOverdue) ? taskOverdueSubtitle : taskDueSubtitle;
            context: { activity }
          "
        ></ng-container>
      </ng-template>
      <crm-activity-template
        [activity]="activity"
        [ownerUser]="activity.ownerUser"
        [isOwnedByServiceAccount]="activity.ownerId === ''"
        [subtitleTemplate]="activity.crmObjectSubtype === 'Task' ? taskSubtitle : undefined"
        [showPrimaryAssociation]="!crmObjectIdentifier().crmObjectId"
      >
        <ng-container *ngIf="!editMode">
          <ng-container [ngSwitch]="activity.crmObjectSubtype">
            <crm-activity-logged-note *ngSwitchCase="'Note'" [activity]="activity"></crm-activity-logged-note>
            <crm-activity-logged-email *ngSwitchCase="'Email'" [activity]="activity"></crm-activity-logged-email>
            <crm-activity-logged-call *ngSwitchCase="'Call'" [activity]="activity"></crm-activity-logged-call>
            <crm-activity-logged-meeting *ngSwitchCase="'Meeting'" [activity]="activity"></crm-activity-logged-meeting>
            <crm-activity-task
              *ngSwitchCase="'Task'"
              [activity]="activity"
              (activityChange)="updateActivity($event)"
              [associatedObject]="crmObjectIdentifier()"
              [users]="uniqueUsers$ | async"
            ></crm-activity-task>
            <crm-activity-logged-communication
              *ngSwitchCase="'Communication'"
              [activity]="activity"
            ></crm-activity-logged-communication>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="editMode">
          <crm-activity-logger
            *ngIf="activity | crmTimelineAssociatedObject: crmObjectIdentifier() as crmActivity"
            crm-activity-template-edit
            [crmObjectId]="crmActivity.crmObjectId"
            [objectType]="crmActivity.objectType"
            [crmActivityId]="activity.crmObjectId!"
            [expandAndSelectType]="activity.crmObjectSubtype"
            [hideCrmObjectAssociations]="hideCrmAssociations()"
            [activityOwner]="activity.ownerUser"
            (cancel)="editMode = false"
            (activityUpdated)="updateActivity($event)"
          ></crm-activity-logger>
        </ng-container>

        <crm-association-popover [activity]="activity"></crm-association-popover>

        <div class="activity-options-menu" crmActivityTemplateOptions *ngIf="!editMode">
          <mat-menu #activityOptionsMenu="matMenu">
            <button mat-menu-item (click)="editMode = true">
              {{ 'ACTIVITY.MENU.EDIT' | translate }}
            </button>
            @if (showCopyLink()) {
              <button mat-menu-item (click)="copyLinkToActivity()">
                {{ 'ACTIVITY.MENU.COPY_LINK' | translate }}
              </button>
            }
          </mat-menu>
          <button mat-icon-button [matMenuTriggerFor]="activityOptionsMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      </crm-activity-template>
    </div>
  </ng-container>
  <ng-template #systemActivity>
    <div
      *ngIf="isActivityValid()"
      [ngSwitch]="activity.crmObjectSubtype"
      class="activity-card"
      [ngClass]="{ 'last-activity-card': isLast }"
    >
      <crm-activity-record-change [activity]="activity" *ngSwitchCase="'RecordChange'"></crm-activity-record-change>
      <crm-activity-note *ngSwitchCase="'Note'" [activity]="activity"></crm-activity-note>
      <crm-activity-email
        *ngSwitchCase="'Email'"
        [activity]="activity"
        [associatedObjectId]="crmObjectIdentifier().crmObjectId"
        [objectType]="crmObjectIdentifier().objectType"
      ></crm-activity-email>
      <crm-activity-call
        *ngSwitchCase="'Call'"
        [activity]="activity"
        [associatedObjectId]="crmObjectIdentifier().crmObjectId"
        [objectType]="crmObjectIdentifier().objectType"
      ></crm-activity-call>
      <crm-activity-communication
        *ngSwitchCase="'Communication'"
        [activity]="activity"
        [associatedObjectId]="crmObjectIdentifier().crmObjectId"
        [objectType]="crmObjectIdentifier().objectType"
      ></crm-activity-communication>
      <crm-activity-opportunity-updated
        *ngSwitchCase="'OpportunityChange'"
        [activity]="activity"
      ></crm-activity-opportunity-updated>
      <crm-activity-meeting
        *ngSwitchCase="'Meeting'"
        [cardInfo]="activity"
        [associatedObjectId]="crmObjectIdentifier().crmObjectId"
        [objectType]="crmObjectIdentifier().objectType"
      ></crm-activity-meeting>
    </div>
  </ng-template>
</div>

<ng-template #taskDueSubtitle let-activity="activity">
  <div>{{ 'ACTIVITY.DUE' | translate }}: {{ activity | crmActivityEffectiveDate | date: dateFormat }}</div>
</ng-template>

<ng-template #taskOverdueSubtitle let-activity="activity">
  <div class="activity-overdue-subtitle">
    <mat-icon>alarm</mat-icon>
    <span>{{ 'ACTIVITY.OVERDUE' | translate }}: {{ activity | crmActivityEffectiveDate | date: dateFormat }}</span>
  </div>
</ng-template>
